import React from "react";
import BlogCategories from "../../components/templates/Blog/BlogCategories";

const Blog = (props) => {
    return (
        <>
            <BlogCategories {...props} />
        </>
    );
};

export async function getStaticProps() {
    let { fetchBlogCategories } = require("../../utils/fetchBuildData");
    return {
        props: {
            blogCategories: await fetchBlogCategories(),
        },
        // revalidate: 60 * 60 * 24 * 1, // 1 days
    };
}
export default Blog;
